import { SendingStatus, Sex } from ".";

/**
 * 消息状态
 * 只用发送失败
 */
export enum EmailMsgStatus {
  /** 发送中 */
  SENDING = "SENDING",
  /** 发送成功 */
  SENT = "SENT",
  /** 发送失败 */
  FAILED = "FAILED",
  /** 发送超时 */
  TIMEOUT = "TIMEOUT",
}

/**
 * 邮件附件类型
 */
export interface IEmailAttachment {
  /** 文件 id  */
  fileId: string;
  /** 文件名称 */
  fileName: string;
  /** 文件大小 */
  fileSize?: number;
  /** 文件类型 */
  fileType?: string;
  /** 文件下载 url */
  fileUrl: string;
  /** 文件上传状态 */
  fileIsUploading?: boolean;
  /** 文件上传进度 */
  fileUploadingProgress?: number;
  /** 文件上传失败 */
  fileUploadFail?: boolean;
}

export type MailDataInfo = {
  chatId: string;
  anotherId: string;
  sender_id: string;
  sender_name?: string;
  receivers: { id: string; name: string }[];
  forwards: { id: string; name: string }[];
  title: string;
  content: string;
  files: IEmailAttachment[];
  timestamp: number;
  /** 用于渲染概述的纯文本 */
  pure_text?: string;

  msg_unique_identifier: string;
  sending_status: SendingStatus;
  another_id: string;
  robot_task_id?: string;
  from_user_id: string;
  request_key?: string;
  chat_id: string;
  positive?: boolean;
  robotId: string;
  rectifyId?: string;
  send_sys_user_name?: string;
  msg_status?: EmailMsgStatus;
};

export type MailConversationDataType = {
  chat_id: string;
  team_id?: string;
  name?: string;
  avatar?: string;
  last_message: MailDataInfo;
  from_user_id?: string;
  // 是否置顶
  is_top?: number;
  // 未读数
  unread?: number;
  // 是否屏蔽
  is_shield?: number;
  conversation_robot_relation?: {
    robotId?: string;
  };
  // 是否托管
  is_trusteeship?: boolean;
  corp_id?: string;
  corp_short_name?: string;
  // 当前会话的对象
  another_id: string;
  timestamp: number;

  sender_id?: string;
};

export type MailContact = {
  id?: string;
  account: string;
  avatar: string;
  city: string;
  country: string;
  from_user_id: string;
  is_wecom: boolean;
  name: string;
  province: string;
  remark: string;
  sex: Sex;
  signature: string;
  user_id: string;
  is_friend?: boolean;
  chat_id: string;
  renderId?: string;
};
